import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["is-80-20-best"]!;

export function Body() {
  return (
    <>
      <p>
        80/20 is a popular rule of thumb for endurance training: about 80 percent of your
        training easy and 20 percent hard. Where does it come from, and is it the best way for a
        recreational runner to train?
      </p>

      <h2>Where it comes from</h2>
      <p>
        In 2010, Stephen Seiler reviewed how well-trained endurance athletes distribute their
        training. Athletes who trained 10 to 13 times a week did about 80 percent of their
        sessions at low intensity. That pattern became known as 80/20.
      </p>
      <p>
        How you count matters. In a study of elite skiers, about 96 percent of training time was
        easy, but only about 87 percent of the sessions. The same training can look like 80/20
        or 95/5 depending on whether you count minutes or sessions.
      </p>

      <h2>What the research found</h2>
      <p>
        A 2025 analysis pooled 13 studies with 348 endurance athletes. It compared polarised
        training, where most of the training is easy and most of the rest is very hard, with
        pyramidal training, which also keeps most training easy but includes more moderate
        running.
      </p>
      <p>
        Overall, there was no difference in maximal oxygen uptake or time-trial performance. But
        the level of the athletes mattered: competitive athletes may gain more from polarised
        training, while recreational athletes may gain more from a pyramidal distribution.
      </p>
      <p>
        One study with 30 recreational runners compared polarised training with a programme
        built on more moderate running. The polarised group improved its 10K time by 5.0 percent
        and the other group by 3.6 percent, but the difference was not statistically significant.
      </p>

      <h2>What it means for you</h2>
      <p>
        Most of your running should be easy. That holds in every version of the research. Beyond
        that, there is no exact split that suits everyone, and as a recreational runner you don't
        need to avoid moderate running. Tempo runs and steady running can be a useful part of
        your week, as long as your easy days stay easy.
      </p>

      <h2>What the research can't tell you</h2>
      <p>
        The studies are relatively short and include different kinds of athletes. They don't
        give a single right percentage for each runner.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training keeps most of your running easy and chooses the harder sessions from your
        goal, your recent training and how you recover. There is no fixed 80/20 quota, and no
        intensity is off limits when a session calls for it.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Seiler (2010), What is best practice for training intensity and duration distribution
          in endurance athletes?{" "}
          <a href="https://doi.org/10.1123/ijspp.5.3.276">International Journal of Sports Physiology and Performance</a>.
        </li>
        <li>
          Sylta, Tønnessen & Seiler (2014), From heart-rate data to training quantification.{" "}
          <a href="https://doi.org/10.1123/IJSPP.2013-0298">International Journal of Sports Physiology and Performance</a>.
        </li>
        <li>
          Rosenblat et al. (2025), Which training intensity distribution intervention will
          produce the greatest improvements in maximal oxygen uptake and time-trial performance in
          endurance athletes?{" "}
          <a href="https://doi.org/10.1007/s40279-024-02149-3">Sports Medicine</a>.
        </li>
        <li>
          Muñoz et al. (2014), Does polarized training improve performance in recreational
          runners?{" "}
          <a href="https://pubmed.ncbi.nlm.nih.gov/23752040/">International Journal of Sports Physiology and Performance</a>.
        </li>
      </ul>
    </>
  );
}
